import React from 'react';
import moment from 'moment';
import { prettyKey } from '../../helpers/formatters';
import { DATE_TIME_FORMAT } from '../../constants';

const RollingArrangement = ({ rollingArrangement }) => {
  if (!rollingArrangement) {
    return null;
  }

  const formatAttrValue = (attr) => {
    if (typeof rollingArrangement[attr] === 'undefined') {
      return null;
    }

    switch (attr) {
      case 'arranged_until':
        return moment(rollingArrangement[attr]).format(DATE_TIME_FORMAT);

      case 'active':
        return rollingArrangement[attr] === null
          ? 'null'
          : rollingArrangement[attr];

      default:
        return (
          rollingArrangement[attr] !== null &&
          rollingArrangement[attr].toString()
        );
    }
  };

  return (
    <table className="table">
      <tbody>
        {[
          'id',
          'user_profile',
          'arrangement_day',
          'card_id',
          'arranged_until',
          'enabled',
          'active',
        ].map((attr) => (
          <tr key={attr}>
            <td>
              <strong>{prettyKey(attr)}</strong>
            </td>
            <td>{formatAttrValue(attr)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default RollingArrangement;
